export const ConstantPageConstant = {
    constants: 'Settings_File_Templates_Constants.constants',
    name: 'Settings_File_Templates_Constants.name',
    edit: 'Settings_File_Templates_Constants.edit',
    delete: 'Settings_File_Templates_Constants.delete'
};
